export const switchClassEstado = estado => {
    switch (estado) {
        case "activo":
            return "label-success"
        case "pendiente_activacion":
            return "label-grey"
        case "pausado":
            return "label-red"
        case "en_revision":
            return "label-primary"
        case "eliminado":
            return "label-grey"
        default:
            return ""
    }
}